import times from 'lodash-es/times'
import * as React from 'react'

import { IProps } from './IProps'
import { Container, Dot } from './styles'

export const PaginationDots: React.FC<IProps> = ({ currentIndex, elementCount }) => {
  return (
    <Container>
      {times(elementCount, index => (
        <Dot key={index} isSelected={currentIndex === index} />
      ))}
    </Container>
  )
}
